/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `app` - App
 * * `asset` - Asset
 * * `content` - Content
 */
export enum FileTypeEnum {
    APP = 'app',
    ASSET = 'asset',
    CONTENT = 'content',
}
